export default "__VITE_ASSET__67391ff9__"